import { connect } from 'react-redux';

import SearchAutocomplete from '../components/ConsumerHeader/SearchAutocomplete';
import {
    searchAutocompleteSuggestions as searchAutocompleteSuggestionsAction,
    searchFilterAction,
} from '../redux/search/actions';
import { trackFeedEvent } from '../redux/app/actions';

const _mapStateToProps = (state) => ({
    suggestions: state.suggestions,
    locationSlug: state.location.slug,
});

const _mapDispatchToProps = {
    onSearchSuggestionChange: searchAutocompleteSuggestionsAction,
    handleApplyFilter: searchFilterAction,
    trackGAEvent: trackFeedEvent,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(SearchAutocomplete);
